import React from 'react'
import { 
    Dialog, 
    DialogContent, 
    DialogTitle, 
    DialogTrigger, 
    DialogDescription 
} from '@/shared/components/ui/dialog'
import { Search } from 'lucide-react'
import VolunteerSearchInput from './volunteer-search-input'

function VolunteerMobileSearchButton() {
    return (
        <VolunteerSearchInput />
    )
}

export default VolunteerMobileSearchButton